export default "__VITE_ASSET__0_EX9cFw__"